//* BREAK Start*/

export const DOWNLOAD_DYNAMIC_REPORT = "DOWNLOAD_DYNAMIC_REPORT";
export const DOWNLOAD_DYNAMIC_REPORT_SUCCESS =
  "DOWNLOAD_DYNAMIC_REPORT_SUCCESS";
export const DOWNLOAD_DYNAMIC_REPORT_FAILED = "DOWNLOAD_DYNAMIC_REPORT_FAILED";

//* BREAK End*/
